import {crudGeneral} from "@/services/resource/GeneralCRUD.service"
import VarType from "@/model/types/resource/VarType"

export default {
    data() {
        return {
            form: {/*Usado para o filtro*/
                default: "", /*Campo principal de busca*/
                status: 0, /*Campo padrão de filtro, porém poderá não ser utilizado, para isso basta declarar sem o mesmo e somente com default */
            },
            request: {
                content:[],
                totalPages: 0
            },
            lastListReqId:0,
            pageNumber: "",
            intervalTimerSearchDefault: null,
            countSendDefaultSearch: 0, //Contador para possibilitar travar as pesquisas evitando sobrecarga no servidor
            pageListIsLoaded: false,
            filteredDefault: false,//Indica se o filtro padrão está em uso
            filteredAdvanced: false,//Indica que está usando os filtros avançados
            foreignKeyColumn:'',//Coluna com chave estrangeira, caso utilizado não será considerado filtro e não irá limpar
            modalOrdained:false, //Usado no dialogo geral de ordenação, caso utilizar um dentro de outro, especificar na página
            searchParams: new URLSearchParams()
        }
    },
    async mounted() {

    },
    methods: {

        async reloadPageList() {
            await this.executeSearch(true)
        },

        afterGetPage() {

        },

        async mountQuery() {


            //Monta a query com os valores padrões
            Object.entries(this.$route.query).forEach(([key, value]) => {

                value = decodeURI(value)

                if (key === 'page') {
                    this.pageNumber = value
                } else {

                    //Verifica se existe o campo na busca nos campos padrões do form
                    if (key in this.form) {

                        //Correção de números
                        if (typeof this.form[key] === 'number') {
                            if (value.indexOf(".") > -1) {
                                value = parseFloat(value)
                            } else {
                                value = parseInt(value)
                            }
                        } else if (Array.isArray(this.form[key])) {
                            //Array declarados e convertidos no recebimento
                            value = value.split(',')
                        }


                        this.form[key] = value


                        this.searchParams.append(key, this.form[key])

                        if (key === 'default') {
                            this.filteredDefault = true
                        } else {
                            this.filteredAdvanced = true
                        }
                    } else if (key.indexOf("field_") > -1) {

                        //Campos customizado, podendo ser geral (page) ou condicionado (exemplo modelId)
                        const queryFieldId = parseInt(key.replace("field_", ""))

                        //console.log('Verifica campo custom: ' + queryFieldId)

                        //Verifica se existem campos customizados na tela
                        if (this.fieldsCustomizable.length > 0) {

                            //Faz a leitura em todas as entidades
                            for (let entity of this.fieldsCustomizable) {


                                //Procura nesta entidade se o campo existe
                                let field = entity.fields.find(a => a.fieldId === queryFieldId)

                                if (field !== undefined) {

                                    let fieldNewValue = undefined

                                    if (field.var) {


                                        //CONVERSÃO DO QUERY PARA inserção no campo no local correto

                                        if (field.var === VarType.type.BOOLEAN) {

                                            if (value === 'true') {
                                                fieldNewValue = true
                                            } else if (value === 'false') {
                                                fieldNewValue = false
                                            }

                                        } else if (field.var === VarType.type.INTEGER) {

                                            fieldNewValue = parseInt(value)

                                        } else if (field.var === VarType.type.DOUBLE) {

                                            fieldNewValue = parseFloat(value)

                                        } else if (field.var === VarType.type.STRING) {

                                            fieldNewValue = value

                                        } else if (field.var === VarType.type.DATE) {

                                            fieldNewValue = value
                                        }

                                    } else {
                                        console.log("Falha modelo do campo não encontrado")
                                    }

                                    if (fieldNewValue !== undefined) {

                                        this.searchParams.append(key, value)
                                        this.filteredAdvanced = true
                                        field.value = fieldNewValue
                                    }

                                    //Pausa a procura, pois foi encontrado
                                    break

                                }
                            }
                        }

                    }
                }

            });

        },


        checkIsFiltered() {
            return this.filteredDefault || this.filteredAdvanced
        },

        checkViewListTableDefault() {
            return !this.pageListIsLoaded || (this.request.content && this.request.content.length > 0)
        },

        async mountedList(setIsLoadingPage = true, setCurrentPage = true) {

            await this.mountedDefault(setIsLoadingPage, setCurrentPage, 'list')

            if (this.breadcrumb.length > 0) {
                this.breadcrumb.push({text: this.currentPage.pageTitle, active: true})
            }

            /*No caso das listagem somente na montagem é verificado os campos*/
            if (this.fieldsCustomizable.length > 0) {

                for (const entity of this.fieldsCustomizable) {
                    await this.getFieldsCustomizable(entity.entity)
                }
            }

            await this.mountQuery()

            await this.getPage(this.pageNumber)

        },

        async clearSearch() {

            //Limpando campos comuns
            Object.keys(this.form).forEach(key => {

                if(this.foreignKeyColumn !== '' && this.foreignKeyColumn === key){
                    //Neste caso não irá limpar
                }else{
                    if (this.form[key] && typeof this.form[key] === "string") {
                        this.form[key] = ''
                    } else if (this.form[key] && typeof this.form[key] === "number") {
                        this.form[key] = 0
                    } else if (typeof this.form[key] === "boolean") {
                        this.form[key] = null
                    } else if (Array.isArray(this.form[key])) {
                        this.form[key] = []
                    }
                }



            })

            //Limpando campso customizáveis

            if (this.fieldsCustomizable.length > 0) {
                for (const entity of this.fieldsCustomizable) {
                    for (let field of entity.fields) {
                        field.value = null
                    }
                }
            }

            setTimeout(async () => {
                await this.executeSearch()
            }, 500)


        },

        searchNotExposeQuery() {

            this.pageListIsLoaded = false
            this.timeSearchSend(() => this.executeSearch(false,false))

        },

        searchDefault() {

            this.pageListIsLoaded = false
            this.timeSearchSend(() => this.executeSearch())

        },

        async executeSearch(persistsPageNumber = false, exposeQueryString = true) {

            this.filteredDefault = false
            this.filteredAdvanced = false


            Object.keys(this.form).forEach((key) => {

                this.searchParams.delete(key)

                let validated = false
                let valueSend = this.form[key]

                if (Array.isArray(this.form[key])) {

                    if (this.form[key].length > 0) {

                        //Padroniza o envio de arrays sempre com separador |, mesmo que o back-end aceite para numeros a separação por ',' porém esta não funciona corretamente em Strings desta forma foi convencionado o pipe
                        let text = this.form[key].join("|")

                        //Envia no padrão in
                        valueSend = "in("+text+")"

                        validated = true


                    }

                } else if (this.form[key] !== '' && this.form[key] !== 0 && this.form[key] !== null) {
                    validated = true
                }

                if (validated) {


                    if (typeof this.form[key] === 'string') {

                        //Coreção para datas com range preenchido parcialmente
                        if (this.form[key].substring(0, 1) === ':') {
                            //Correção aplicada em campos range início
                            this.form[key] = this.form[key].substring(1)
                        } else if (this.form[key].substring(this.form[key].length - 1) === ':') {
                            //Correção aplicada em campos range no final
                            this.form[key] = this.form[key].substring(0, this.form[key].length - 1)
                        }

                        //Coreção para numeros com range preenchido parcialmente
                        if (this.form[key].substring(0, 2) === '0:') {
                            //Correção aplicada em campos range início
                            this.form[key] = this.form[key].substring(2)
                        } else if (this.form[key].substring(this.form[key].length - 2) === ':0') {
                            //Correção aplicada em campos range no final
                            this.form[key] = this.form[key].substring(0, this.form[key].length - 2)
                        }

                    }

                    this.searchParams.append(key, valueSend)

                    if (key === 'default') {
                        this.filteredDefault = true
                    } else if(key !== this.foreignKeyColumn) {
                        this.filteredAdvanced = true
                    }

                }

            })

            //Injeta campos customizaveis caso necessário na entidade
            if (this.fieldsCustomizable.length > 0) {

                for (const entity of this.fieldsCustomizable) {

                    const fieldCustomized = await this.requestFieldCustomized(entity.entity, entity.fields, true)
                    const fields = fieldCustomized.fields

                    let findEntityUsed = false
                    //Remove a marcação indicando que a entidade foi usada na busca, servirá para casos especiais onde se é necessário saber antes se algum campo da entidade foi usado na busca como no caso de Produtos
                    this.searchParams.delete('entity-'+entity.entity)

                    for (const field of fields) {

                        const key = "field_" + field.fieldId
                        const value = field.value

                        this.searchParams.delete(key)

                        if (field.hasValue) {

                            findEntityUsed = true

                            this.searchParams.append(key, value) //Qualquer um dos campos avançados será considerado com utilizado filtro avançado
                            this.filteredAdvanced = true
                        }

                    }

                    if(findEntityUsed)
                        this.searchParams.append('entity-'+entity.entity, 'true')

                }
            }

            if (persistsPageNumber) {
                await this.getPage(this.$route.query.page,false,exposeQueryString)
            } else {
                await this.getPage(1,false,exposeQueryString)
            }


        },

        timeSearchSend(callback) {
            // sempre reinicia
            if (this.timerSearchDefault) {
                clearTimeout(this.timerSearchDefault)
            }

            this.timerSearchDefault = setTimeout(async () => {
                this.timerSearchDefault = null
                await callback()
            }, 500)
        },

       /* timeSearchSend(callback) {


            if (this.intervalTimerSearchDefault == null) {

                console.log('ignorado')

                this.intervalTimerSearchDefault = setInterval(async () => {

                    this.countSendDefaultSearch++

                    if (this.countSendDefaultSearch === 1) {
                        /!*Enviando pesquisa de forma pausada para evitar erro no servidor*!/

                        clearInterval(this.intervalTimerSearchDefault)
                        this.countSendDefaultSearch = 0
                        this.intervalTimerSearchDefault = null

                        console.log('ok enviado pesquisa')

                        await callback()


                    }

                }, 500)

            }


        },*/

        async getPageNotExposeQuery(pageNumber) {
          await this.getPage(pageNumber,false,false)
        },

        openDialogOrdained() {
            this.modalOrdained = true
            this.openDialogForm('modal-ordained') //Id padrão
        },

        async getPage(pageNumber, mountAgain = false, exposeQueryString = true) {

            if (mountAgain) {
                await this.mountedPrepare()
                await this.mountedList()
            } else {


                const reqId = ++this.lastListReqId   // gera um id unico para esta chamada

                //console.log('reqId atual: ' + reqId)
                //console.log('lastListReqId: ' + this.lastListReqId)

                this.pageListIsLoaded = false

                let query = {}

                if (pageNumber !== undefined && pageNumber !== null && pageNumber > 1)
                    query.page = "" + pageNumber


                this.pageNumber = pageNumber

                this.searchParams.forEach((value, key) => {
                    query[key] = encodeURI(value)
                })

                //console.log("Antes query: ")
                //console.log(this.$route.query)

                //console.log("Depois query: ")
                //console.log(query)

                //Altera na rota somente se for diferente
                if(exposeQueryString){

                    if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {

                        //Expõe parametros no link acima
                        await this.$router.replace({query: query})

                    }

                    //Armazena a última página de listagem, caso queria depois voltar
                    const lastPage = {
                        name: this.$route.name,
                        path: this.$route.path,
                        query,
                    }

                    this.$store.commit("setLastPage", lastPage)

                }

                //DEVERÁ MONTAR OS PARÂMETROS DINAMICAMENTE CONFORME OS CAMPOS FOREM MARCADOS COMO DE PESQUISA
                await crudGeneral.getAll(this.getPath(), pageNumber, this.searchParams)
                    .then(response => {

                        // se ja existe uma requisicao mais nova, ignora esta resposta antiga
                        if (reqId !== this.lastListReqId){
                            //console.log('reqId atual: ' + reqId + ' ignorado!')
                            return
                        }

                        this.request = response.data
                        this.pageListIsLoaded = true
                        this.afterGetPage()


                    })
                    .catch(error => {

                        // se ja existe uma requisicao mais nova, ignora esta resposta antiga
                        if (reqId !== this.lastListReqId){
                            //console.log('reqId atual: ' + reqId + ' ignorado!')
                            return
                        }

                        console.log('Erro externo: ' + error)
                    })


            }


        },


    },
    computed: {

        //Não necessário mais
        //pageNumber() {
        //    return this.$route.query.page
        //},
    },


}


